import type { IconGlyph } from '../icon';

/**
 * Tractie `report-thick` glyph (medium, 24×24), shown on the current nav item.
 *
 * Source: `@tractie/icons` v1.5.0, `dist/jsx/m/report-thick.jsx`.
 * Verbatim copy of the SVG `d` attributes, 3 paths in source order.
 */
export const iconReportThick: IconGlyph = {
  name: 'report-thick',
  path: [
    'M8.03 8h3c.55 0 1-.45 1-1s-.45-1-1-1h-3c-.55 0-1 .45-1 1s.45 1 1 1m4 1h-4c-.55 0-1 .45-1 1s.45 1 1 1h4c.55 0 1-.45 1-1s-.45-1-1-1',
    'M17.03 15V3.5c0-.83-.67-1.5-1.5-1.5h-11c-.83 0-1.5.67-1.5 1.5v15c0 .83.67 1.5 1.5 1.5h7.5zm-5 2.17V15h2.17zm-2 .83h-5V4h10v9h-5z',
    'M18.53 5h-.5v16h-12v.5c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5v-15c0-.83-.67-1.5-1.5-1.5',
  ],
};
